export default "__VITE_ASSET__uQFVncxL__"